// client/src/components/LoadingOverlay.jsx
import React from "react";

const LoadingOverlay = ({ text = "Molimo sačekajte..." }) => {
  return (
    <div className="loading-overlay">
      <div className="loading-box">
        <div className="spinner" />
        <p>{text}</p>
      </div>
    </div>
  );
};

export default LoadingOverlay;
